import { Skeleton } from "@/components/ui/skeleton";

/**
 * Folder List Skeleton
 *
 * Loading placeholder for folder sidebar.
 */
export function FolderSkeleton() {
  return (
    <div className="w-full flex items-center gap-2 px-3 py-2">
      <Skeleton className="w-4 h-4 rounded" />
      <Skeleton className="h-4 flex-1" />
      <Skeleton className="w-6 h-4 rounded" />
    </div>
  );
}

/**
 * Multiple Folder Skeletons
 */
export function FolderListSkeleton({ count = 5 }) {
  return (
    <div className="space-y-2">
      {[...Array(count)].map((_, i) => (
        <FolderSkeleton key={i} />
      ))}
    </div>
  );
}

/**
 * Sidebar Skeleton
 *
 * Complete sidebar loading state.
 */
export function SidebarSkeleton() {
  return (
    <div className="w-64 flex-shrink-0 space-y-2">
      <div className="flex items-center justify-between mb-3">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-7 w-16 rounded" />
      </div>

      <Skeleton className="h-9 w-full rounded-md mb-2" />
      <Skeleton className="h-9 w-full rounded-md mb-2" />

      <div className="h-px bg-slate-200 my-2" />

      <FolderListSkeleton count={4} />
    </div>
  );
}
